<div class="daily-report-table-container">
  <mat-card class="report-card">
    <mat-card-content>
      <h2 class="table-header">
        <span class="user-name">{{ title }}</span>
        @if (dayInfo) {
          <span class="day-info">
            {{ dayInfo.date.toLocaleDateString('hu-HU') }} &middot; {{ dayInfo.dayName }}
          </span>
        }
      </h2>

      <div class="table-wrapper">
        <table class="report-table" (mouseleave)="clearHover()">
          <thead>
            <tr>
              <th class="status-corner">Státusz</th>
              @for (status of statuses; track status.value; let colIndex = $index) {
                <th class="status-header" [class.highlight]="hoveredCol === colIndex">{{ status.label }}</th>
              }
              <th class="total-header" [class.highlight]="hoveredCol === -1">Összesen</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.label; let rowIndex = $index) {
              <tr>
                <td class="hour-cell" [class.highlight]="hoveredRow === rowIndex">{{ row.label }}</td>
                @for (count of row.counts; track $index; let colIndex = $index) {
                  <td class="value-cell" [class.zero]="count === 0"
                      (mouseenter)="onCellHover(rowIndex, colIndex)">{{ count }}</td>
                }
                <td class="row-total-cell" (mouseenter)="onCellHover(rowIndex, -1)">{{ row.total }}</td>
              </tr>
            }
            <tr class="totals-row">
              <td class="hour-cell" [class.highlight]="hoveredRow === -1">{{ totalsRow.label }}</td>
              @for (count of totalsRow.counts; track $index; let colIndex = $index) {
                <td class="value-cell" (mouseenter)="onCellHover(-1, colIndex)">{{ count }}</td>
              }
              <td class="row-total-cell grand-total" (mouseenter)="onCellHover(-1, -1)">{{ totalsRow.total }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
